export class ClientAppSettings {
    public static readonly ASSETWORXWEBCLIENTID:string = "AssetWorxWeb";
    public static readonly ASSETWORXWEBCLIENTSECRET:string = "";
    public static readonly AMSCLIENTID: string = "AlarmMonitoringService";        
    public static readonly ASSETWORXMOBILECLIENTID: string = "AssetWorxMobile";
    public static readonly ASSETWORXMOBILECLIENTSECRET: string = "y2OfpwA33LnU4tlEcG8cfpitEI40l1unNug0e0lnwoWz0hEdRo";
    public static readonly HANDHELDSYNCCLIENTID: string = "AssetWorxHandheldSync";
    public static readonly RADSCLIENTID: string = "AssetWorxRADS";
    public static readonly ALARMNOTIFIERCLIENTID: string = "AssetWorxAlarmNotifier";
}
